import React from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';

import Section from '../../components/layout/Section';
import { Medium, Light } from '../../components/UI/Text';  
import { FONT, MAIN_BLUE } from '../../styles/color';
import CHECKED from '../../assets/imgs/checked.png';

const Container = styled.div`
    width: 100%;
    height: 500px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
`;

export default function OrderSuccess() {
    const location = useLocation();
    const { orderNumber } = location.state || {};

    return (
        <Section>
            <Container>
                <img
                    alt="success_icon"
                    width="120px" height="120px"
                    src={CHECKED}
                />
                <Medium size="32px">주문이 완료되었습니다.</Medium>
                {/* TODO: 입금기한 조정 */}
                <Light size="18px" style={{ lineHeight : '1.5em', textAlign : 'center' }}>
                    주문번호 <span style={{ color : FONT.deep01 }}>{orderNumber}</span><br/>
                    입금기한 <span style={{ color : MAIN_BLUE.deep }}>{"2025-05-11 15:59"}</span><br/>
                    기한 내 미입금 시 주문이 자동 취소됩니다.
                </Light>
            </Container>
        </Section>
    );
}